import { render, staticRenderFns } from "./Canteen.vue?vue&type=template&id=40ad3b81&"
import script from "./Canteen.vue?vue&type=script&lang=js&"
export * from "./Canteen.vue?vue&type=script&lang=js&"
import style0 from "./Canteen.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports